import { Injectable } from '@angular/core';
import { PatientAPIResponse, Patient } from '../interfaces/patient';
import { IdentifierAPIResponse } from '../interfaces/identifier';
import { AddressAdapter } from './address.adapter';
import { QualificationAdapter } from './qualification.adapter';
import { TelecomAdapter } from './telecom.adapter';

@Injectable({
  providedIn: 'root',
})
export class PatientAdapter {
  constructor(
    private addressAdapter: AddressAdapter,
    private qualificationAdapter: QualificationAdapter,
    private telecomAdapter: TelecomAdapter
  ) {}

  public adapterToModel(patientFHIR: PatientAPIResponse): Patient {
    const identifier = this.extractIdentifiers(patientFHIR.identifier);
    const telecom = this.telecomAdapter.adapterToModel(patientFHIR?.telecom!);

    const address = this.addressAdapter.adapterToModel(patientFHIR.address[0]);

    return {
      patient_id: patientFHIR.patient_id,
      name: patientFHIR.name,
      gender: patientFHIR.gender,
      birthDate: patientFHIR.birthDate,
      cpf: identifier.CPF ?? '',
      mobile: telecom?.mobile ?? undefined,
      phone: telecom?.mobile ?? undefined,
      email: telecom?.email ?? undefined,
      avatar: undefined,
      active: patientFHIR.active,
      address: address,
      token_id: patientFHIR.token_id,
      photo: patientFHIR.photo,
      created_by: patientFHIR.created_by
    };
  }

  public adaptToAPIFormat(patientModel: Patient): PatientAPIResponse {
    return {
      patient_id: patientModel.patient_id,
      name: patientModel.name,
      avatar: undefined,
      identifier: [{ value: patientModel.cpf, system: 'CPF' }],
      gender: patientModel.gender,
      birthDate: patientModel.birthDate,
      telecom: this.telecomAdapter.adaptToAPIFormat(
        patientModel.email,
        patientModel.phone,
        patientModel.mobile
      ),
      address: patientModel.address
        ? this.addressAdapter.adaptToAPIFormat(patientModel.address)
        : [],
      active: patientModel.active,
      token_id: patientModel.token_id,
      photo: patientModel.photo,
      created_by: patientModel.created_by
    };
  }

  private extractIdentifiers(identifiers: IdentifierAPIResponse[]) {
    let CPF: string | null = null;
    let CRM: string | null = null;
    let CNPJ: string | null = null;

    identifiers.forEach((identifier) => {
      const { system, value } = identifier;

      if (system === 'CPF') {
        CPF = value;
      } else if (system === 'CRM') {
        CRM = value;
      } else if (system === 'CNPJ') {
        CNPJ = value;
      }
    });

    return { CPF, CRM, CNPJ };
  }
}
